<template>
  <div>
    <el-table
        :data="tableList" :border="true">
      <el-table-column label="购销身份" width="100">
        <template #default>购货方</template>
      </el-table-column>

      <el-table-column label="对方纳税人名称" align="center" prop="seller.name" min-width="200"/>

      <el-table-column label="纳税人识别号" align="center" prop="seller.taxRegistrationNo" min-width="160"/>
      <el-table-column label="对应蓝票全电发票号码" align="center" prop="item.allInvoiceNumber" min-width="180"/>
      <el-table-column label="红字通知单号" align="center" min-width="130"/>


      <el-table-column label="发票金额" prop="item.amount" align="center" min-width="130">
        <template #default="{row}">
          <span v-if="row.item?.amount != null">{{ row.item.amount.toFixed(2) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="发票税额" align="center" prop="item.taxAmount" min-width="130">
        <template #default="{row}">
          <span v-if="row.item?.taxAmount != null">{{ row.item.taxAmount.toFixed(2) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="冲红原因" prop="checker" width="100"/>

      <el-table-column label="状态" width="100">
        <template #default>
          <span>正常发票</span>
        </template>
      </el-table-column>

      <el-table-column label="开具状态" prop="kaijuStatus" width="100">
        <template #default="{ row }">
          <span>{{ ['未开具', '已开具'][row.kaijuStatus] }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120" fixed="right">
        <template #default="{ row }">
          <el-button type="primary" link @click="view(row)">查看</el-button>
          <el-button type="primary" link @click="confirm(row)">确认</el-button>
        </template>
      </el-table-column>
    </el-table>

    <detail-dialog
        v-model:visible="detailVis"
        is-outer-view
        :current-row="currentRow"
    />
  </div>
</template>

<script setup>
import {convertBaseData, useSave39Qa} from "./initialDataHelp.js";
import DetailDialog from "./detailDialog.vue";
import {ElMessage} from "element-plus";
import {$emit} from "vue-happy-bus";

const tableList = ref([])
const currentQa = inject('provideCurrentQa');

onMounted(() => {
  const initialData = currentQa.value.initialAnswer && JSON.parse(currentQa.value.initialAnswer) || []
  tableList.value = convertBaseData(initialData)
})

const detailVis = ref(false)
const currentRow = ref({})

function view(row) {
  currentRow.value = row
  detailVis.value = true
}

const {currentSaveTag} = useSave39Qa(currentQa, currentRow)

function confirm(row) {
  currentRow.value = row
  ElMessageBox.confirm("你要确认该红字发票吗？", "提示信息")
      .then(() => {
        ElMessage.success('确认成功')
        currentSaveTag.value = 1
        $emit("exeSaveQa");
      })
      .catch(() => {
      })
}

</script>


<style scoped lang="scss">

</style>
